import React from 'react'
import {
  TitlePrimary,
  ButtonPrimary,
  ButtonTertiary,
  SpacerVertical,
  NavigationContainer,
  constants
} from 'mage-deps/@klarna/bubble-ui'
import PropTypes from 'prop-types'
import { Message, hooks as i18nHooks } from 'mage-i18n'
import { useHelpContext } from './hooks'
import { CMSEntry } from 'mage-cms'
import { EducationAnalytics } from 'education-tools'

NeedHelpPopup.propTypes = {
  isOpen: PropTypes.bool,
  onYes: PropTypes.func,
  onNo: PropTypes.func,
  onElse: PropTypes.func,
  title: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
}

function NeedHelpPopup({ isOpen = false, onYes, onNo, onElse, title, t }) {
  return (
    <div
      style={{
        background: 'transparent',
        width: 45 * constants.Grid.SIZE,
        position: 'fixed',
        bottom: isOpen ? 32 * constants.Grid.SIZE : '-100%',
        right: 4 * constants.Grid.SIZE,
        zIndex: 999,
        boxSizing: 'border-box',
        transition: 'bottom .2s ease-in-out'
      }}
    >
      <NavigationContainer>
        <div style={{ padding: 4 * constants.Grid.SIZE }}>
          <TitlePrimary small>{title}</TitlePrimary>
          <div
            style={{
              marginTop: 4 * constants.Grid.SIZE,
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <ButtonPrimary data-test-id="need-help-popup-yes" onClick={onYes}>
              {t('hqm.popup.yes', {}, 'Yes')}
            </ButtonPrimary>
            <SpacerVertical extraSmall />
            <ButtonTertiary onClick={onNo}>{t('hqm.popup.no', {}, 'No')}</ButtonTertiary>
            <SpacerVertical small />
            <div
              style={{
                color: 'white',
                textDecoration: 'underline',
                textAlign: 'center',
                cursor: 'pointer',
                ...constants.Fonts.KLARNA_TEXT_REGULAR
              }}
            >
              <a onClick={onElse}>
                <Message
                  path="hqm.popup.somethingElse"
                  fallback="I need help with something else"
                />
              </a>
            </div>
          </div>
        </div>
      </NavigationContainer>
    </div>
  )
}

function Connected() {
  const t = i18nHooks.useTranslator()
  const {
    popup: { popupSlug },
    setIsOpen,
    navigation,
    removePopup,
    hidePopup
  } = useHelpContext()

  if (!popupSlug) return null

  return (
    <CMSEntry contentType="UHQMPopup" filters={{ slug: popupSlug }}>
      {popup => (
        <>
          <EducationAnalytics
            category="uhqm/need-help-popup"
            action="print"
            label={popup.slug}
            referenceType="popup"
            referenceId={popup.id}
            skip={!popupSlug}
            googleAnalytics={false}
          />
          <EducationAnalytics
            category="uhqm/need-help-popup"
            action="click"
            referenceType="popup"
            referenceId={popup.id}
          >
            {track => (
              <NeedHelpPopup
                t={t}
                isOpen={!!popupSlug}
                onYes={() => {
                  track({ label: 'yes' })
                  removePopup(popupSlug)
                  switch (popup.target.contentType) {
                    case 'UHQMTopic':
                      navigation.push('topic', { topicSlug: popup.target.slug })
                      break
                    case 'UHQMArticle':
                      navigation.push('article', { articleSlug: popup.target.slug })
                      break
                    case 'Link':
                      window.open(popup.target.url, '_blank', 'noopener')
                      break
                  }
                }}
                onNo={() => {
                  track({ label: 'no' })
                  hidePopup(popupSlug)
                }}
                onElse={() => {
                  track({ label: 'other' })
                  removePopup(popupSlug)
                  navigation.reset()
                  setIsOpen(true)
                }}
                title={popup.body}
              />
            )}
          </EducationAnalytics>
        </>
      )}
    </CMSEntry>
  )
}

export { NeedHelpPopup, Connected }

export default Connected
